<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('chat-bots') }} -> {{ $t('queries') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('client') }}</th>
            <th scope="col">{{ $t('query') }}</th>
            <th scope="col">{{ $t('date') }}</th>
            <th scope="col">{{ $t('messenger') }}</th>
          </tr>
          </thead>
          <tbody v-if="allRequests.length > 0">
          <tr v-for="(item, index) in allRequests" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td>{{ fullNames[index] }}</td>
            <td class="pointer link-blue" @click="viewRequest(item.id)">{{ item.query }}</td>
            <td>{{ item.date_create }}</td>
            <td>{{ setMessenger[index] }}</td>
          </tr>
          </tbody>
          <div class="tbody-empty" v-else>
            <p>Ничего не найдено</p>
          </div>
        </table>
        <div class="form-row justify-content-center" v-if="allRequests.length < countRequests">
          <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";

export default {
  name: 'requests',
  data: function(){
    return{
      data: {
        page: 1
      },
    }
  },
  computed: {
    ...mapGetters(['allRequests', 'countRequests']),
    fullNames: function(){
      return this.allRequests.map(function(item) {
        if(!item.middlename && !item.firstname && !item.lastname){
          return '-';
        }
        return (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '');
      });
    },
    setMessenger: function(){
      return this.allRequests.map(function(item) {
        if(item.type == 1){
          return 'Telegram';
        }else if(item.type == 2){
          return 'Viber';
        }
      });
    },
  },
  async mounted() {
    this.getRequest();
  },
  methods: {
    viewRequest: function(requestId){
      this.$router.push({
        path: `/view-request/${requestId}`
      });
    },
    nextPage: function(){
      this.data.page++;
      this.getRequest();
    },
    getRequest: function(){
      this.$store.dispatch('fetchRequest', this.data);
    },
  },
}
</script>